<script lang="ts">
  import { mobileMenuActivity } from '@shared/lib/stores';
  import Wallet from '../../wallet.svelte';
  import { page } from '$app/stores';
  import { cn } from '@shared/lib';
  import { getLinkVisibility, navigationConfig } from '@entities/navigation';

  $: hasAuctions = $page.data.institutionAuctionsCount > 0;
  $: hasArtists = $page.data.institutionArtistsCount > 0;
</script>

<ul class="flex w-full grow flex-col justify-center overflow-auto pt-20">
  {#each navigationConfig.navigationLinks as { link, title }, index}
    {@const isVisible = getLinkVisibility(title, { hasAuctions, hasArtists })}

    {#if isVisible}
      <li
        class="{cn('mb-1 overflow-hidden', {
          'mb-0': index === navigationConfig.navigationLinks.length - 1,
        })}"
      >
        <div
          class="transition-transform duration-300"
          class:-translate-y-full="{!$mobileMenuActivity}"
          style="transition-delay: {$mobileMenuActivity ? 500 + index * 100 : 300 - index * 50}ms"
        >
          <a href="/{link}" class="text-6xl font-medium" on:click="{() => mobileMenuActivity.toggle()}">
            {title}
          </a>
        </div>
      </li>
    {/if}
  {/each}

  <li class="overflow-hidden">
    <div
      class="{cn('transition-transform duration-300', {
        '-translate-y-[105%]': !$mobileMenuActivity,
      })}"
      style="transition-delay: {$mobileMenuActivity ? 1000 : 50}ms"
    >
      <Wallet />
    </div>
  </li>
</ul>
